import { useQuery } from '@tanstack/react-query';
import { getCellHoverContent } from './cellHoverService';

export const CELL_HOVER_QUERY_KEY = 'cellHover';

/**
 * Fetch cell hover HTML content (for preview overlay)
 * @param {string | null} url - The hover URL to fetch (null disables the query)
 * @param {QueriesOptions} [options = {}] - The query options
 * @returns {import('@tanstack/react-query').UseQueryResult<CellHoverContent, Error>}
 */
export const useCellHoverContent = (url, options = {}) => useQuery({
  queryKey: [CELL_HOVER_QUERY_KEY, url],
  queryFn: () => getCellHoverContent(/** @type {string} */ (url)),
  enabled: !!url,
  ...options,
});
